;
var pageInitialized = false;
var site = {};
site.inits = [];

site.megamenu = {};
site.megamenu.init = function() {
	var $container = $('#mainmenu');
	$container.find('>ul>li').each(function() {
		var $li = $(this);
		var id = $li.attr('class').split(' ')[0];
		var $megamenu = $('.menuBox', $li);

		// If there is no megamenu for division we don't bind
		if ($megamenu.length > 0) {
			$('> .level1 a', $li).bind('click', function(e) {
				e.preventDefault();
				e.stopPropagation();

				if ($(this).closest('li').hasClass('open')) {
					site.megamenu.closeAll();
				}
				else {
					site.megamenu.open($li, id);
				}
			});
		}
	});

	var $division = $('#breadcrumbs .first');

	if($division) {
		$division.bind('click', function (e) {
			e.preventDefault();
			e.stopPropagation();

			var $container = $('#mainmenu');
			$container.find('>ul>li').each(function() {
				var $li = $(this);
				var id = $li.attr('class').split(' ')[0];
				if($('> .level1 a', $li).attr('href') === $division.attr('href')) {
					if ($(this).closest('li').hasClass('open')) {
						site.megamenu.closeAll();
					}
					else {
						site.megamenu.open($li, id);
					}
				}
			});
		});
	}

	$container.on('click', function(e) {
		e.stopPropagation();
	});
	var $body = $('body');
	$body.on('click', function() {
		if ($body.is('.megaOpen')) {
			site.megamenu.closeAll();
		}
	});

	$(document).keydown(function (e) {
		if (e.which === 27 && $body.hasClass('megaOpen')) {
			site.megamenu.closeAll();
			var $level1 = $(e.target).closest('.level1');
			$('> a', $level1).focus();
		}
	});

	site.megamenu.background();
};

site.megamenu.open = function(li, id) {
	site.megamenu.closeAll();
	li.addClass('open');
	$('body').addClass('megaOpen');
	site.megamenu.setHeight();
};

site.megamenu.closeAll = function() {
	$('#mainmenu').find('li.open').removeClass('open');
	//$('#megaMenu .menuBox a').removeAttr('tabindex');
	$('body').removeClass('megaOpen');
	$('#megamenuBg').removeAttr('style');
	$('.menuBox').removeAttr('style');
};

site.megamenu.background = function() {
	$(window).resize(function() {
		site.megamenu.setHeight();
	});
	$('#megamenuBg').on('click touchstart', function(e) {
		e.stopPropagation();
	});
};

site.megamenu.setHeight = function() {
	var $megamenu = $('.menuBox', '#mainmenu li.open');
	if ($megamenu.length > 0) {
		var $megamenuHeight = $megamenu[0].scrollHeight + 30;
		$('#contentContainer').css('min-height', $megamenuHeight);
		$('#megamenuBg').css('height', $megamenuHeight);
		$megamenu.css('max-height', $megamenuHeight);
	}
};

site.dropdown = {
	init:function() {
		var $body = $('body');
		if (!$body.hasClass('frontpage')) return false;

		site.dropdown.setHeight();
		$(window).resize(function() {
			site.dropdown.setHeight();
		});

		$('.content','.dropdown').on('click', function(e) {
			e.stopPropagation();
		});
		$('.title', '.dropdown').on('click', function(e) {
			e.preventDefault();
			e.stopPropagation();
			var $parent = $(this).parent();
			if (!$parent.hasClass('open')) {
				$('.category.dropdown').removeClass('open');
				$parent.addClass('open');
				$body.addClass('dropdown-open');
			}
			else {
				site.dropdown.close();
			}

			$('body.dropdown-open').on('click', function () {
				site.dropdown.close();
			});
		});
	},

	setHeight:function() {
		var $dropdown = $('.dropdown');
		$('ul', $dropdown).show();
		$('.content', $dropdown).each(function() {
			$(this).css('max-height', $(this)[0].scrollHeight);
		});
		$('ul', $dropdown).removeAttr('style');
	},

	close:function() {
		$('.category.dropdown').removeClass('open');
		setTimeout(function() {
			$('body').removeClass('dropdown-open');
		},400);
	}
};

site.maxHeight = {
	init: function (selector) {
		if (!selector || $(selector).length == 0) return;
		site.maxHeight.setHeight(selector);
		$(window).resize(function () {
			site.maxHeight.setHeight(selector);
		});
	},

	setHeight: function (selector) {
		$(selector).each(function () {
			$(this).css('max-height', $(this)[0].scrollHeight);
		});
	}
};


site.frontpage = {
	init: function () {
		var $body = $('body');
		if (!$body.hasClass('frontpage') && $body.hasClass('is')) return false;

		$('#box_group_form').on('click touchStart', function(e) {
			e.stopPropagation();
		});
		$('#box_group_form .box_html, #formToggle').on('click touchStart', function(e) {
			e.preventDefault();
			e.stopPropagation();

			$body.toggleClass('form-open');

			$('body.form-open').on('click touchStart', function(e) {
				$body.removeClass('form-open');
			});
		});

		$(window).load(function() {
			site.maxHeight.init('#box_group_form .box_custom');
		});
	}
};

site.accessibility = {
	init:function() {
		if ($('body').hasClass('admin')) return;

		$(document).keydown(function (e) {
			if (e.which == 9) {
				$('body').addClass('tabbing');
			}
		});
		$(document).mousedown(function (e) {
			$('body').removeClass('tabbing');
		});
	}
};

site.stillingar = {
	skip: function() {
		$('#qn .gtranslate a, .goog-te-gadget, .goog-te-gadget-simple').addClass('ms_skip');
		$('.bestur').addClass('ms_skip');
		//$('#megaMenu').addClass('ms_skip');
		$('.arrow, .overlay', '#homeCarousel').addClass('ms_skip');
		$('.text, .content, .more', '#banner').addClass('ms_skip');
		$('#meetingWrap').addClass('ms_skip');

		$(window).load(function() {
			$('.arrow, .overlay', '#homeCarousel').addClass('ms_skip');
		});
	}
};

// Run all the inits \o/
$(function() {
	$.each(site.inits, function(i, value) {
		var fun = new Function(value);
		fun();
	});
	site.frontpage.init();
	site.megamenu.init();
	site.dropdown.init();
	site.accessibility.init();

	var $w = $(window);

	var $qn = $('#qn');
	$qn.find('ul li ul').parent().addClass('drop');
	$qn.find('.drop a').click(function(e) {
		$qn.css('overflow','visible');
		$qn.find('.drop ul').toggle();
	});
	$qn.find('ul li ul').hover(function(){
	},function() {
		$qn.find('.drop ul').toggle();
	});

	$('#searchBox #searchSubmit').hover(function() {
		setEyesHover(true);
	},function() {
		setEyesHover(false);
	});

	$('.shareThis').click(function(e) {
		e.preventDefault();
		var width = ($(this).data('width') !== undefined) ? $(this).data('width') : 550;
		var height = ($(this).data('height') !== undefined) ? $(this).data('height') : 500;
		popCenter($(this).attr('href'), 'shareWindow', width, height);
	});
	/*
	$('#divisions a span').each(function() {
		$(this).append('<p class="expand">+</p>');
	});
	*/
	/*
	 var $div = $('#divisions');
	 $div.find('li').bind('mouseenter',function() {
	 var $this = $(this);
	 var id = $this.attr('class').split(' ')[0];
	 // Close all
	 $div.find('li.open').removeClass('open');
	 $('#megaMenu .menuBox').hide().removeClass('open');

	 // Open this one
	 $this.addClass('open');
	 $('#megaMenu .'+id).show().addClass('open');
	 });
	 $div.find('li').bind('mouseleave',function() {
	 $(this).removeClass('open');
	 $('#megaMenu .menuBox').hide().removeClass('open');
	 });
	 $('#megaMenu .menuBox').bind('mouseenter',function() {
	 var $this = $(this);
	 var id = $this.attr('class').split(' ')[0];
	 $this.show().addClass('open');
	 $('#divisions li.'+id).addClass('open');
	 });
	 $('#megaMenu .menuBox').bind('mouseleave',function() {
	 $div.find('li.open').removeClass('open');
	 $(this).hide().removeClass('open');
	 });
	 */
	$('#mobileBar .menuToggle').click(function(e) {
		menuToggle(e);
	});
	$('#abendingar #fieldset_noFieldset').prepend('<div class="or" />');
	//Scroll top
	var goUp = $('#up');

	$w.scroll(function() {
		if ($('body').width() > 1343-15) {
			if ($w.scrollTop() > 500) {
				goUp.fadeIn();
			} else {
				goUp.fadeOut();
			}
		}
	});
	goUp.click(function(e) {
		$('html,body').animate({
			scrollTop:0
		},300);
		event.preventDefault();
	});
	addMenu();
	$w.resize(function() {
		addMenu();
	});
	$('#meetingBoxes .boxTitle').click(function() {
		$(this).parent().find('ul').slideToggle();
	});
	$('#frontSocial .fblImg').bind("click touchstart",function(){
		$(this).children('span').hide();
		$(this).children('div.fb-like').show().children('span').show();
	});

	windowSize();
	var $promo = $('#promoIs ul');
	$promo.anythingSlider({
		buildNavigation:false,
		buildStartStop:false,
		hashTags: false,
		autoPlay:false,
		delay:7000,
		onSlideBegin:function(){ $('.homeCarousel li .text').fadeOut(),$('.homeCarousel li.activePage .text').fadeOut()},
		onSlideComplete:function(b){b.$currentPage.find('.text').fadeIn()}
	});
	$promo.find('ul').attr('data-expanded',true);
	$promo.addClass('carousel homeCarousel clearfix anythingBase horizontal');
	$('#ahrif,#ahrif2').append('<div id=\"nav\" />');
	$('#ahrif,#ahrif2').parents('.box').addClass('slides');
	/*
	$('#frontTabs .box').each(function(i) {
		$('.frontTabs').append('<li><a href=\"#'+$(this).attr('id')+'\">'+$('.boxTitle h2',this).text()+'</a></li>');
	});
	*/
	$promo.find('a.more').wrapInner('<span></span>');

	if ($('body').hasClass('thatttaka')) {
		$('#ahrif').append('<div id=\"nav\" />');
		$('#ahrif').parents('.box').addClass('slides');
		$('.thatttaka .box_ord_1.box_newsheadlines').append('<div id=\"nav2\" />');
	}

});

function popCenter(url, title, w, h) {
	var dualScreenLeft = window.screenLeft !== undefined ? window.screenLeft : screen.left;
	var dualScreenTop = window.screenTop !== undefined ? window.screenTop : screen.top;

	var width = window.innerWidth ? window.innerWidth : document.documentElement.clientWidth ? document.documentElement.clientWidth : screen.width;
	var height = window.innerHeight ? window.innerHeight : document.documentElement.clientHeight ? document.documentElement.clientHeight : screen.height;

	var left = ((width / 2) - (w / 2)) + dualScreenLeft;
	var top = ((height / 2) - (h / 2)) + dualScreenTop;
	var newWindow = window.open(url, title, 'scrollbars=0, toolbar=0, width=' + w + ', height=' + h + ', top=' + top + ', left=' + left);

	// Puts focus on the newWindow
	if (window.focus) {
		newWindow.focus();
	}
}

function addMenu() {
	if($(window).width() + 15 < 768) {
		var $flags = $('#qn li.drop');
		$('#mMenu .mmLevel0').append('<li class="otherWeb"><a href="">'+$flags.find('a:first').html()+'</a><ul class="menu mmLevel1 hide mm-list mm-panel mm-hidden" id="mobile-999">'+$flags.find('ul').html()+'</ul></li>');
		$('#mMenu .mmLevel0').append('<li class="ibuagatt">'+$('.ibuagatt a', '#mainmenu')[0].outerHTML+'</li>');
		$('#mMenu .mmLevel0').append('<li class="mobileQn"></li>');
		$('#menu').mmenu({
			position: 'right',
			classes: "mm-light"
		}, {
			selectedClass: 'active'
		});

		if($('#menu #mobile-1 li.lang').length == 0) {
			let html = $('#searchBox #searchForm').clone();
			$('#q', html).attr('name', 'searchrequest');
			$('#q', html).attr('aria-autocomplete', 'list');
			$('#q', html).attr('aria-haspopup', 'true');
			$('#menu #mobile-1').prepend('<li class="search"><form id="searchFormMobile" name="searchFormMobile">'+ html.html()+'</form></li>');
			setTimeout(() => {
				if (typeof registerMobileInput === "function") {
					// þetta er global function sem kemur frá cludo
					registerMobileInput();
				}
			}, 500);
			$('#menu #mobile-1').prepend('<li class="lang">'+'<a class="phone">'+$flags.prev().html()+'</a></li>');
		}
		$('body.is.frontpage #menu #mobile-5 .mm-subclose').trigger('click');
	}
}
$(document).mousemove(function(e) {
	//setEyes(e);
});

function setEyes(e) {
	var eyes = $('#searchBox #searchSubmit');
	if (!eyes.length) {
		return;
	}
	var eyesTop =  eyes.offset().top+35;
	var eyesLeft = eyes.offset().left;
	// x pos
	if(e.pageX < eyesLeft) {
		eyes.removeClass('look-right');
		eyes.addClass('look-left');
	}
	else if(e.pageX > (eyesLeft + 70)) {
		eyes.removeClass('look-left');
		eyes.addClass('look-right');
	}
	else {
		eyes.removeClass('look-right look-left');
	}
	// Y pos
	if(e.pageY < eyesTop) {
		eyes.removeClass('look-down');
		eyes.addClass('look-up');
	}
	else if(e.pageY > (eyesTop + 58)) {
		eyes.removeClass('look-up');
		eyes.addClass('look-down');
	}
	else {
		eyes.removeClass('look-down look-up');
	}
}

function setEyesHover(hover) {
	var eyes = $('#searchBox #searchSubmit');
	if(hover) {
		eyes.removeClass().addClass('hover');
	}
	else {
		eyes.removeClass('hover');
	}
}

function menuToggle(e) {
	$('body').toggleClass('open-menu');
	$(this).toggleClass('open');
}
function fixHeight(a,b) {
	var bl = a.height();
	var br = b.height();
	if(bl < br) {
		a.height(br);
	}
	else {
		b.height(bl);
	}
}

$(window).load(function() {
	var cardLeft = 0;
	var cardRight = 0;
	$('body.is.frontpage .box_newsheadlines li').each(function(i) {
		if(i > 0 && i%2 == 1) {
			var cardLeft = $(this).height();
			var cardRight = $(this).next().height();
			if(cardLeft < cardRight) {$(this).height(cardRight);}
			else {$(this).next().height(cardLeft);}
		}
	});

	if ($('body').hasClass('thatttaka')) {
		fixHeight($('#center .box_ord_2'),$('#center .box_ord_3'));
		fixHeight($('#center .box_ord_4'),$('#center .box_ord_5'));
		fixHeight($('#center .box_ord_7'),$('#center .box_ord_8'));
		$('#center .box_newsheadlines.last li').height(Math.max.apply(Math,$('#center .box_newsheadlines.last li').map(function() {return $(this).height()})));

		$('#center .box_ord_7 .boxText img, #center .box_ord_8 .boxText img').height($('#center .box_ord_7').height());
	}
	if($('body').is('.is,.frontpage')) {
		if ($('#box1 .box_ord_4').length > 0) {
			fixHeight($('#box1 .box_ord_4'),$('#box1 .box_ord_3'));
		} else {
			fixHeight($('#box1 .box_ord_2'),$('#box1 .box_ord_3'));
		}
		fixHeight($('#box2 .box_ord_0'),$('#box2 .box_ord_1'));
		fixHeight($('#box2 .box_ord_1'),$('#box2 .box_ord_2'));
		$('#box1 .shortcut a').wrapInner('<span />');
	}
});
$(window).resize(function() {
	windowSize();
});
function windowSize() {
	var w = $(document).width() + 15;
	if(w > 991) {
		$('body').addClass('big').removeClass('mobile');
	} else {
		$('body').addClass('mobile').removeClass('big');
	}
}

function share_fb(url) {
	window.open('https://www.facebook.com/sharer/sharer.php?u='+url,'facebook-share-dialog',"width=626, height=436")
}
